/** Public support and site identity (floai.studio). Override with NEXT_PUBLIC_* if needed. */
export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? 'support@floai.studio';

/** Server: where contact-form submissions are delivered (single support inbox). */
export function getContactInboxEmail(): string {
  return process.env.CONTACT_INBOX_EMAIL ?? process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? 'support@floai.studio';
}
export const PRIVACY_EMAIL = process.env.NEXT_PUBLIC_PRIVACY_EMAIL ?? 'privacy@floai.studio';
export const SECURITY_EMAIL = process.env.NEXT_PUBLIC_SECURITY_EMAIL ?? 'security@floai.studio';
export const NOREPLY_EMAIL = process.env.NEXT_PUBLIC_NOREPLY_EMAIL ?? 'noreply@floai.studio';

/** Default public site URL when env is unset (referral links, etc.). */
export const DEFAULT_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? 'https://floai.studio';

/**
 * User-facing refund rules: narrow window from first charge (no rolling “30 days” each cycle);
 * renewals / late-in-period requests limited.
 */
export const REFUND_POLICY_USER_SUMMARY =
  'You may request a full refund within 14 calendar days of your first paid charge only (after any trial). That window does not reset each billing cycle. Completed subscription periods are non-refundable—use Manage billing to cancel before renewal if you do not want the next charge. Requests made within 5 calendar days before a scheduled renewal may be limited to stopping the upcoming charge rather than refunding time already used in the current period, except where law requires otherwise.';
